// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Welcome Screen Styles */

.welcomeScreen_welcomeScreen__m2Efr {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 16px 24px;
  max-width: 1200px;
  width: 100%;
  margin: 0 auto;
  min-height: auto;
  flex: 1 1;
  gap: 16px;
}

.welcomeScreen_welcomeScreenCompact__Nz7qr {
  padding: 12px;
  max-width: 100%;
  gap: 12px;
}

.welcomeScreen_welcomeScreenCompact__Nz7qr .welcomeScreen_welcomeHeader__-RRcc {
  margin-bottom: 10px;
}

.welcomeScreen_welcomeScreenCompact__Nz7qr .welcomeScreen_aiGradientIcon__vetir {
  width: 40px;
  height: 40px;
  font-size: 20px;
  border-radius: 10px;
}

.welcomeScreen_welcomeScreenCompact__Nz7qr .welcomeScreen_welcomeTitle__84ffy {
  font-size: 20px !important;
}

.welcomeScreen_welcomeScreenCompact__Nz7qr .welcomeScreen_welcomeSubtitle__i36Yp {
  font-size: 12px;
}

.welcomeScreen_welcomeScreenCompact__Nz7qr .welcomeScreen_exampleCategories__nlBVw {
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 12px;
  margin-bottom: 16px;
}

.welcomeScreen_welcomeScreenCompact__Nz7qr .welcomeScreen_exampleChip__iHaSj {
  padding: 4px 10px;
}

.welcomeScreen_welcomeScreenCompact__Nz7qr .welcomeScreen_chipText__QvHTk {
  font-size: 12px;
  white-space: normal;
}

.welcomeScreen_welcomeScreenCompact__Nz7qr .welcomeScreen_capabilities__XMqkB {
  padding: 12px 14px;
}

.welcomeScreen_welcomeScreenCompact__Nz7qr .welcomeScreen_capabilitiesList__NCLED {
  grid-template-columns: 1fr;
  justify-items: center;
}

.welcomeScreen_welcomeScreenCompact__Nz7qr .welcomeScreen_capabilitiesList__NCLED li {
  font-size: 11px;
  text-align: left;
  width: 100%;
  max-width: 260px;
  padding-left: 0;
}

.welcomeScreen_welcomeScreenCompact__Nz7qr .welcomeScreen_poweredByText__s0zUq {
  font-size: 10px;
}
.welcomeScreen_welcomeHeader__-RRcc {
  text-align: center;
  margin-bottom: 14px;
  max-width: 700px;
}

.welcomeScreen_welcomeIcon__CDFXp {
  margin-bottom: 12px;
  display: flex;
  justify-content: center;
}

.welcomeScreen_aiGradientIcon__vetir {
  width: 50px;
  height: 50px;
  border-radius: 12px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 26px;
  color: white;
  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.25);
  animation: welcomeScreen_floatAnimation__prxIC 3s ease-in-out infinite;
}

@keyframes welcomeScreen_floatAnimation__prxIC {
  0%,
  100% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-10px);
  }
}

.welcomeScreen_welcomeTitle__84ffy {
  margin-bottom: 8px !important;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  font-size: 28px !important;
  line-height: 1.2;
}

.welcomeScreen_brandingContainer__YCb47 {
  margin-bottom: 10px;
}

.welcomeScreen_welcomeBranding__MQ3l1 {
  font-size: 15px;
  color: #262626;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  line-height: 1.3;
}

.welcomeScreen_welcomeBranding__MQ3l1 strong {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  font-weight: 700;
  font-size: 16px;
}

.welcomeScreen_brandIcon__GgnHA {
  font-size: 16px;
  animation: welcomeScreen_sparkle__fg4Lb 2s ease-in-out infinite;
}

@keyframes welcomeScreen_sparkle__fg4Lb {
  0%, 100% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.6;
    transform: scale(1.1);
  }
}

.welcomeScreen_welcomeSubtitle__i36Yp {
  font-size: 13px;
  color: #595959;
  line-height: 1.5;
}

.welcomeScreen_exampleCategories__nlBVw {
  width: 100%;
  max-width: 920px;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 20px;
  margin-bottom: 16px;
  justify-items: center;
}

.welcomeScreen_exampleCategory__6n1n5 {
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: center;
  text-align: center;
  width: 100%;
  max-width: 260px;
}

.welcomeScreen_categoryHeader__repQz {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 4px;
  justify-content: center;
}

.welcomeScreen_categoryIcon__QNcXZ {
  font-size: 20px;
}

.welcomeScreen_categoryTitle__ehwU3 {
  font-size: 14px;
  font-weight: 600;
  color: #262626;
}

.welcomeScreen_exampleChips__KUx0B {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: center;
}

.welcomeScreen_exampleChip__iHaSj {
  display: inline-flex;
  align-items: center;
  padding: 6px 12px;
  background: #ffffff;
  border: 1.5px solid #e8e8e8;
  border-radius: 20px;
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
  text-align: center;
}

.welcomeScreen_exampleChip__iHaSj:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  border-width: 1.5px;
}

.welcomeScreen_chipText__QvHTk {
  font-size: 13px;
  color: #262626;
  line-height: 1.4;
  margin: 0;
  white-space: nowrap;
}

.welcomeScreen_capabilities__XMqkB {
  width: 100%;
  max-width: 860px;
  padding: 16px 20px;
  background: #f5f5f5;
  border-radius: 10px;
  text-align: center;
}

.welcomeScreen_capabilitiesTitle__n51SI {
  display: block;
  font-size: 12px;
  font-weight: 600;
  color: #262626;
  margin-bottom: 10px;
}

.welcomeScreen_capabilitiesList__NCLED {
  list-style: none;
  padding: 0;
  margin: 0;
  text-align: left;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 6px 20px;
}

.welcomeScreen_capabilitiesList__NCLED li {
  font-size: 12px;
  color: #595959;
  line-height: 1.5;
  padding-left: 4px;
}

.welcomeScreen_poweredBy__Ey-Ni {
  margin-top: 14px;
  padding-top: 12px;
  border-top: 1px solid #e8e8e8;
}

.welcomeScreen_poweredByText__s0zUq {
  font-size: 11px;
  color: #8c8c8c;
  font-weight: 500;
  letter-spacing: 0.3px;
}

/* Streaming Text Cursor */
.welcomeScreen_streaming-cursor__LyKx7 {
  animation: welcomeScreen_cursorBlink__5g-HR 1s step-end infinite;
  color: #1677ff;
  font-weight: bold;
}

@keyframes welcomeScreen_cursorBlink__5g-HR {
  0%,
  50% {
    opacity: 1;
  }
  51%,
  100% {
    opacity: 0;
  }
}

/* Mobile Responsive */
@media (max-width: 768px) {
  .welcomeScreen_welcomeScreen__m2Efr {
    padding: 20px 16px;
  }

  .welcomeScreen_welcomeHeader__-RRcc {
    margin-bottom: 24px;
  }

  .welcomeScreen_aiGradientIcon__vetir {
    width: 60px;
    height: 60px;
    font-size: 30px;
  }

  .welcomeScreen_welcomeTitle__84ffy {
    font-size: 24px !important;
  }

  .welcomeScreen_welcomeSubtitle__i36Yp {
    font-size: 14px;
  }

  .welcomeScreen_exampleCategories__nlBVw {
    grid-template-columns: 1fr;
    gap: 20px;
    margin-bottom: 24px;
  }

  .welcomeScreen_categoryIcon__QNcXZ {
    font-size: 18px;
  }

  .welcomeScreen_categoryTitle__ehwU3 {
    font-size: 13px;
  }

  .welcomeScreen_exampleChip__iHaSj {
    padding: 5px 10px;
  }

  .welcomeScreen_chipText__QvHTk {
    font-size: 12px;
  }

  .welcomeScreen_capabilitiesList__NCLED {
    grid-template-columns: 1fr;
    gap: 6px;
  }

  .welcomeScreen_capabilitiesList__NCLED li {
    font-size: 12px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/AICopilot/styles/welcomeScreen.module.css"],"names":[],"mappings":"AAAA,0BAA0B;;AAE1B;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,cAAc;EACd,gBAAgB;EAChB,SAAO;EACP,SAAS;AACX;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,6DAA6D;EAC7D,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,gDAAgD;EAChD,sEAAiD;AACnD;;AAEA;EACE;;IAEE,0BAA0B;EAC5B;EACA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE,6BAA6B;EAC7B,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,+DAA0C;AAC5C;;AAEA;EACE;IACE,UAAU;IACV,mBAAmB;EACrB;EACA;IACE,YAAY;IACZ,qBAAqB;EACvB;AACF;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;EACnB,eAAe;EACf,iDAAiD;EACjD,yCAAyC;EACzC,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;EACzC,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,aAAa;EACb,2DAA2D;EAC3D,aAAa;AACf;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA,0BAA0B;AAC1B;EACE,gEAA2C;EAC3C,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE;;IAEE,UAAU;EACZ;EACA;;IAEE,UAAU;EACZ;AACF;;AAEA,sBAAsB;AACtB;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;IAC1B,QAAQ;EACV;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":["/* Welcome Screen Styles */\n\n.welcomeScreen {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 16px 24px;\n  max-width: 1200px;\n  width: 100%;\n  margin: 0 auto;\n  min-height: auto;\n  flex: 1;\n  gap: 16px;\n}\n\n.welcomeScreenCompact {\n  padding: 12px;\n  max-width: 100%;\n  gap: 12px;\n}\n\n.welcomeScreenCompact .welcomeHeader {\n  margin-bottom: 10px;\n}\n\n.welcomeScreenCompact .aiGradientIcon {\n  width: 40px;\n  height: 40px;\n  font-size: 20px;\n  border-radius: 10px;\n}\n\n.welcomeScreenCompact .welcomeTitle {\n  font-size: 20px !important;\n}\n\n.welcomeScreenCompact .welcomeSubtitle {\n  font-size: 12px;\n}\n\n.welcomeScreenCompact .exampleCategories {\n  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));\n  gap: 12px;\n  margin-bottom: 16px;\n}\n\n.welcomeScreenCompact .exampleChip {\n  padding: 4px 10px;\n}\n\n.welcomeScreenCompact .chipText {\n  font-size: 12px;\n  white-space: normal;\n}\n\n.welcomeScreenCompact .capabilities {\n  padding: 12px 14px;\n}\n\n.welcomeScreenCompact .capabilitiesList {\n  grid-template-columns: 1fr;\n  justify-items: center;\n}\n\n.welcomeScreenCompact .capabilitiesList li {\n  font-size: 11px;\n  text-align: left;\n  width: 100%;\n  max-width: 260px;\n  padding-left: 0;\n}\n\n.welcomeScreenCompact .poweredByText {\n  font-size: 10px;\n}\n.welcomeHeader {\n  text-align: center;\n  margin-bottom: 14px;\n  max-width: 700px;\n}\n\n.welcomeIcon {\n  margin-bottom: 12px;\n  display: flex;\n  justify-content: center;\n}\n\n.aiGradientIcon {\n  width: 50px;\n  height: 50px;\n  border-radius: 12px;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 26px;\n  color: white;\n  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.25);\n  animation: floatAnimation 3s ease-in-out infinite;\n}\n\n@keyframes floatAnimation {\n  0%,\n  100% {\n    transform: translateY(0px);\n  }\n  50% {\n    transform: translateY(-10px);\n  }\n}\n\n.welcomeTitle {\n  margin-bottom: 8px !important;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  font-size: 28px !important;\n  line-height: 1.2;\n}\n\n.brandingContainer {\n  margin-bottom: 10px;\n}\n\n.welcomeBranding {\n  font-size: 15px;\n  color: #262626;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  line-height: 1.3;\n}\n\n.welcomeBranding strong {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  font-weight: 700;\n  font-size: 16px;\n}\n\n.brandIcon {\n  font-size: 16px;\n  animation: sparkle 2s ease-in-out infinite;\n}\n\n@keyframes sparkle {\n  0%, 100% {\n    opacity: 1;\n    transform: scale(1);\n  }\n  50% {\n    opacity: 0.6;\n    transform: scale(1.1);\n  }\n}\n\n.welcomeSubtitle {\n  font-size: 13px;\n  color: #595959;\n  line-height: 1.5;\n}\n\n.exampleCategories {\n  width: 100%;\n  max-width: 920px;\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n  gap: 20px;\n  margin-bottom: 16px;\n  justify-items: center;\n}\n\n.exampleCategory {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  align-items: center;\n  text-align: center;\n  width: 100%;\n  max-width: 260px;\n}\n\n.categoryHeader {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 4px;\n  justify-content: center;\n}\n\n.categoryIcon {\n  font-size: 20px;\n}\n\n.categoryTitle {\n  font-size: 14px;\n  font-weight: 600;\n  color: #262626;\n}\n\n.exampleChips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  justify-content: center;\n}\n\n.exampleChip {\n  display: inline-flex;\n  align-items: center;\n  padding: 6px 12px;\n  background: #ffffff;\n  border: 1.5px solid #e8e8e8;\n  border-radius: 20px;\n  cursor: pointer;\n  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);\n  text-align: center;\n}\n\n.exampleChip:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n  border-width: 1.5px;\n}\n\n.chipText {\n  font-size: 13px;\n  color: #262626;\n  line-height: 1.4;\n  margin: 0;\n  white-space: nowrap;\n}\n\n.capabilities {\n  width: 100%;\n  max-width: 860px;\n  padding: 16px 20px;\n  background: #f5f5f5;\n  border-radius: 10px;\n  text-align: center;\n}\n\n.capabilitiesTitle {\n  display: block;\n  font-size: 12px;\n  font-weight: 600;\n  color: #262626;\n  margin-bottom: 10px;\n}\n\n.capabilitiesList {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  text-align: left;\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 6px 20px;\n}\n\n.capabilitiesList li {\n  font-size: 12px;\n  color: #595959;\n  line-height: 1.5;\n  padding-left: 4px;\n}\n\n.poweredBy {\n  margin-top: 14px;\n  padding-top: 12px;\n  border-top: 1px solid #e8e8e8;\n}\n\n.poweredByText {\n  font-size: 11px;\n  color: #8c8c8c;\n  font-weight: 500;\n  letter-spacing: 0.3px;\n}\n\n/* Streaming Text Cursor */\n.streaming-cursor {\n  animation: cursorBlink 1s step-end infinite;\n  color: #1677ff;\n  font-weight: bold;\n}\n\n@keyframes cursorBlink {\n  0%,\n  50% {\n    opacity: 1;\n  }\n  51%,\n  100% {\n    opacity: 0;\n  }\n}\n\n/* Mobile Responsive */\n@media (max-width: 768px) {\n  .welcomeScreen {\n    padding: 20px 16px;\n  }\n\n  .welcomeHeader {\n    margin-bottom: 24px;\n  }\n\n  .aiGradientIcon {\n    width: 60px;\n    height: 60px;\n    font-size: 30px;\n  }\n\n  .welcomeTitle {\n    font-size: 24px !important;\n  }\n\n  .welcomeSubtitle {\n    font-size: 14px;\n  }\n\n  .exampleCategories {\n    grid-template-columns: 1fr;\n    gap: 20px;\n    margin-bottom: 24px;\n  }\n\n  .categoryIcon {\n    font-size: 18px;\n  }\n\n  .categoryTitle {\n    font-size: 13px;\n  }\n\n  .exampleChip {\n    padding: 5px 10px;\n  }\n\n  .chipText {\n    font-size: 12px;\n  }\n\n  .capabilitiesList {\n    grid-template-columns: 1fr;\n    gap: 6px;\n  }\n\n  .capabilitiesList li {\n    font-size: 12px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"welcomeScreen": `welcomeScreen_welcomeScreen__m2Efr`,
	"welcomeScreenCompact": `welcomeScreen_welcomeScreenCompact__Nz7qr`,
	"welcomeHeader": `welcomeScreen_welcomeHeader__-RRcc`,
	"aiGradientIcon": `welcomeScreen_aiGradientIcon__vetir`,
	"welcomeTitle": `welcomeScreen_welcomeTitle__84ffy`,
	"welcomeSubtitle": `welcomeScreen_welcomeSubtitle__i36Yp`,
	"exampleCategories": `welcomeScreen_exampleCategories__nlBVw`,
	"exampleChip": `welcomeScreen_exampleChip__iHaSj`,
	"chipText": `welcomeScreen_chipText__QvHTk`,
	"capabilities": `welcomeScreen_capabilities__XMqkB`,
	"capabilitiesList": `welcomeScreen_capabilitiesList__NCLED`,
	"poweredByText": `welcomeScreen_poweredByText__s0zUq`,
	"welcomeIcon": `welcomeScreen_welcomeIcon__CDFXp`,
	"floatAnimation": `welcomeScreen_floatAnimation__prxIC`,
	"brandingContainer": `welcomeScreen_brandingContainer__YCb47`,
	"welcomeBranding": `welcomeScreen_welcomeBranding__MQ3l1`,
	"brandIcon": `welcomeScreen_brandIcon__GgnHA`,
	"sparkle": `welcomeScreen_sparkle__fg4Lb`,
	"exampleCategory": `welcomeScreen_exampleCategory__6n1n5`,
	"categoryHeader": `welcomeScreen_categoryHeader__repQz`,
	"categoryIcon": `welcomeScreen_categoryIcon__QNcXZ`,
	"categoryTitle": `welcomeScreen_categoryTitle__ehwU3`,
	"exampleChips": `welcomeScreen_exampleChips__KUx0B`,
	"capabilitiesTitle": `welcomeScreen_capabilitiesTitle__n51SI`,
	"poweredBy": `welcomeScreen_poweredBy__Ey-Ni`,
	"streaming-cursor": `welcomeScreen_streaming-cursor__LyKx7`,
	"cursorBlink": `welcomeScreen_cursorBlink__5g-HR`
};
export default ___CSS_LOADER_EXPORT___;
